import emitter from 'global-emitter'

export function showDebugConfigModal () {
    emitter.emit('showDebugConfigModal')
}
